

// src/components/Hero/Hero.js


// import React from 'react';
// import './Hero.css';

// const Hero = () => {
//   // Function to handle CV download
//   const handleDownloadCV = () => {
//     const link = document.createElement('a');
//     link.href = '/files/Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf';
//     link.download = 'Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf';
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <section id="home" className="hero">
//       <div className="container">
//         <div className="hero-content">
//           <div className="hero-text">
//             <h1 className="animate-text">
//               Hi, I'm <span>Habiba Shahidi</span>
//             </h1>

//             <p className="animate-text">
//               A Frontend Developer specializing in <strong>Web & Mobile Applications</strong>,
//               building responsive web interfaces with <strong>React</strong> and
//               cross-platform mobile apps with <strong>React Native</strong>.
//             </p>

//             <div className="hero-buttons animate-text">
//               <a href="#projects" className="btn btn-primary">View My Work</a>
//               <a href="#contact" className="btn btn-secondary">Get In Touch</a>
//               <button onClick={handleDownloadCV} className="btn btn-cv">
//                 <i className="fas fa-download"></i> Download CV
//               </button>
//             </div>
//           </div>

//           <div className="hero-image animate-image">
//             <div className="profile-image-container">
//               <img 
//                 src="/images/ProfilePic.jpeg" 
//                 alt="Habiba Shahidi - Software Developer (Web & Mobile)" 
//                 className="profile-image"
//               />
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

// src/components/Hero/Hero.js
import React from 'react';
import { ArrowRight, Download, Mail, ChevronRight } from 'lucide-react';
import './Hero.css';

const Hero = ({ scrollToSection }) => {

    const handleDownloadCV = () => {
    const link = document.createElement('a');
    link.href = '/files/Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf';
    link.download = 'Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-text">👋 Welcome to my portfolio</span>
          </div>
          
          <h1 className="hero-title">
            Hi, I'm <span className="text-gradient">Habiba Shahidi</span>
          </h1>
          
          <h2 className="hero-subtitle">
            Software Developer specializing in Web & Mobile Applications
          </h2>
          
          <p className="hero-description">
            Building responsive web interfaces with React and cross-platform mobile apps with React Native. 
            Passionate about creating beautiful, functional, and user-friendly applications.
          </p>
          
          <div className="about-stats">
            <div className="stat">
               <div className="stat-card">
              <div className="stat-number">12+</div>
              <div className="stat-label">Projects</div>
              </div>
            </div>
            <div className="stat">
                <div className="stat-card">
              <div className="stat-number">6+</div>
              <div className="stat-label">Years Experience</div>
              </div>
            </div>
            <div className="stat">
               <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>
          </div>
          
          <div className="hero-buttons">
            <button 
              className="btn btn-primary"
              onClick={() => scrollToSection('projects')}
            >
              <span>View My Work</span>
              <ArrowRight size={20} />
            </button>
            
            <button 
              className="btn btn-secondary"
              onClick={() => scrollToSection('contact')}
            >
              <Mail size={20} />
              <span>Get In Touch</span>
            </button>
            
            <a 
              href="/files/Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf" 
              className="btn btn-outline"
              download="Habiba_Shahidi_Software_Developer_ReactJS_ReactNative.pdf"
            >
              <Download size={20} />
              <span>Download CV</span>
            </a>

           
          </div>
          
          {/* <div className="hero-tech">
            <span className="tech-label">Tech Stack:</span>
            <div className="tech-icons">
              <div className="tech-icon" title="React">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" />
              </div>
              <div className="tech-icon" title="React Native">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React Native" />
              </div>
              <div className="tech-icon" title="JavaScript">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript" />
              </div>
              <div className="tech-icon" title="TypeScript">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" alt="TypeScript" />
              </div>
              <div className="tech-icon" title="Node.js">
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js" />
              </div>
            </div>
          </div> */}

          <div className="hero-tech">
  <span className="tech-label">Tech Stack:</span>
  <div className="tech-icons">
    {/* <div className="tech-icon" title="React">
      <img 
        src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" 
        alt="React" 
        style={{ filter: 'none' }}
      />
    </div> */}
    <div className="tech-icon" title="React Native">
      <img 
        src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg" 
        alt="React Native" 
        style={{ filter: 'none' }}
      />
    </div>
    <div className="tech-icon" title="JavaScript">
      <img 
        src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg" 
        alt="JavaScript" 
        style={{ filter: 'none' }}
      />
    </div>
    <div className="tech-icon" title="TypeScript">
      <img 
        src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg" 
        alt="TypeScript" 
        style={{ filter: 'none' }}
      />
    </div>
    <div className="tech-icon" title="Node.js">
      <img 
        src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original.svg" 
        alt="Node.js" 
        style={{ filter: 'none' }}
      />
    </div>
  </div>
</div>
        </div>
        
        <div className="hero-image">
          <div className="profile-image-container">
            <div className="profile-image-wrapper">
              {/* Replace with your actual profile image URL */}
              <img 
               src="/images/ProfilePic.jpeg" 
//                 alt="Habiba Shahidi - Software Developer (Web & Mobile)" 
//                 className="profile-image"
               // src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                alt="Habiba Shahidi"
                className="profile-image"
              />
              <div className="image-decoration"></div>
              <div className="image-decoration-2"></div>
              
              {/* Experience badge */}
              <div className="experience-badge">
                <div className="badge-content">
                  <span className="badge-years">6+</span>
                  <span className="badge-text">Years Experience</span>
                </div>
              </div>
              
              {/* Available badge */}
              <div className="available-badge">
                <div className="dot"></div>
                <span>Available for work</span>
              </div>
            </div>
            
            {/* Floating elements */}
            <div className="floating-element element-1">
              <div className="floating-icon">
                <ChevronRight size={24} />
              </div>
              <span>React Expert</span>
            </div>
            
            <div className="floating-element element-2">
              <div className="floating-icon">
                <ChevronRight size={24} />
              </div>
              <span>UI/UX Focus</span>
            </div>
            
            <div className="floating-element element-3">
              <div className="floating-icon">
                <ChevronRight size={24} />
              </div>
              <span>Mobile Apps</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll indicator */}
      <div className="scroll-indicator" onClick={() => scrollToSection('about')}>
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <span>Scroll down</span>
      </div>
    </section>
  );
};

export default Hero;

// import React from 'react';
// import { ArrowRight, Download, Mail } from 'lucide-react';
// import './Hero.css';

// const Hero = ({ scrollToSection }) => {
//   return (
//     <section id="home" className="hero">
//       <div className="container">
//         <div className="hero-content">
//           <div className="hero-badge">
//             <span className="badge-text">Welcome to my portfolio</span>
//           </div>
          
//           <h1 className="hero-title">
//             Hi, I'm <span className="text-gradient">Habiba Shahidi</span>
//           </h1>
          
//           <h2 className="hero-subtitle">
//             A Frontend Developer specializing in Web & Mobile Applications
//           </h2>
          
//           <p className="hero-description">
//             Building responsive web interfaces with React and cross-platform mobile apps with React Native.
//             Passionate about creating beautiful, functional, and user-friendly applications.
//           </p>
          
//           <div className="hero-buttons">
//             <button 
//               className="btn btn-primary"
//               onClick={() => scrollToSection('projects')}
//             >
//               <span>View My Work</span>
//               <ArrowRight size={20} />
//             </button>
            
//             <button 
//               className="btn btn-secondary"
//               onClick={() => scrollToSection('contact')}
//             >
//               <Mail size={20} />
//               <span>Get In Touch</span>
//             </button>
            
//             <a 
//               href="/resume.pdf" 
//               className="btn btn-outline"
//               download
//             >
//               <Download size={20} />
//               <span>Download CV</span>
//             </a>
//           </div>
//         </div>
        
//         <div className="hero-image">
//           <div className="image-placeholder">
//             <div className="code-bg">
//               <pre>
//                 <code>
// {`const developer = {
//   name: "Habiba Shahidi",
//   role: "Full Stack Developer",
//   skills: ["React", "React Native", "Node.js"],
//   passion: "Creating amazing digital experiences"
// };`}
//                 </code>
//               </pre>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;